import { useNavigate } from 'react-router-dom';
import { MessageSquare } from 'lucide-react';
import { useAuth } from '../contexts/useAuth';
import { useMainCourante } from '../contexts/useMainCourante';

export default function MainCourantePopup() {
  const { authorizedApps } = useAuth();
  const { unreadMessages, unreadCount, latestUnreadMessage } = useMainCourante();
  const navigate = useNavigate();

  const canAccess = authorizedApps.includes('hub_maincourante');

  if (!canAccess || unreadMessages.length === 0 || !latestUnreadMessage) return null;

  const authorNames = Array.from(new Set(unreadMessages.map((m) => m.author_name)));

  const goToMainCourante = () => {
    navigate('/main-courante');
  };

  return (
    <div className="fixed inset-0 z-[90] flex items-center justify-center bg-black/60 backdrop-blur-sm px-4">
      <div className="relative w-full max-w-md bg-hub-card border border-hub-border rounded-2xl shadow-2xl p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="flex items-center justify-center w-11 h-11 rounded-full bg-hub-blue/20 text-hub-blue">
            <MessageSquare size={22} />
          </div>
          <div>
            <p className="text-xs uppercase tracking-widest text-hub-muted font-bold">
              Main Courante
            </p>
            <p className="text-hub-text font-semibold">
              {unreadCount > 1 ? `${unreadCount} nouveaux messages` : 'Nouveau message'}
            </p>
          </div>
        </div>

        <p className="text-hub-text text-sm mb-4">
          <span className="font-bold text-hub-accent">
            {authorNames.length > 1
              ? `${authorNames.slice(0, -1).join(', ')} et ${authorNames[authorNames.length - 1]}`
              : authorNames[0]}
          </span>{' '}
          {authorNames.length > 1 ? 'ont laissé des messages' : 'a laissé un message'} :
        </p>

        <div className="space-y-2 mb-5 max-h-48 overflow-y-auto">
          {unreadMessages.map((m) => (
            <div key={m.id} className="bg-hub-bg border border-hub-border rounded-lg p-3">
              <p className="text-hub-text font-medium text-sm">{m.title}</p>
              <p className="text-hub-muted text-xs mt-0.5">{m.author_name}</p>
            </div>
          ))}
        </div>

        <div className="flex justify-end">
          <button
            onClick={goToMainCourante}
            className="flex items-center gap-2 bg-hub-blue hover:bg-hub-blue-hover text-white text-xs font-bold uppercase tracking-widest px-5 py-2.5 rounded transition-colors"
          >
            Lire le message
          </button>
        </div>
      </div>
    </div>
  );
}
